import { EntitlementsProject } from '@adsk/alloy-provider';
import { Row } from '@adsk/alloy-react-table';
import { DEFAULT_LIMIT } from '../constants';

export type CellProps = {
  row: Row<EntitlementsProject>;
  value: string;
};

export const calculatePageFromOffset = (offset: number): number => {
  if (offset < 0) return -1;
  return offset / DEFAULT_LIMIT + 1;
};
